import { css, cx } from "@emotion/css";
import { mergeProps } from "react-aria";
import { TabPanel as AriaTabPanel, TabPanelProps } from "react-aria-components";

import { TabPanelContext } from "../context";

export function TabPanel(props: TabPanelProps) {
  return (
    <TabPanelContext.Provider value={{ id: props.id }}>
      <AriaTabPanel
        {...mergeProps(props, {
          className: cx("react-aria-TabPanel", styles.tabPanel),
        })}
      />
    </TabPanelContext.Provider>
  );
}

const styles = {
  tabPanel: css({
    outline: "none",
    "&[data-focus-visible]": {
      boxShadow: "var(--focus-action)",
    },
  }),
};
